import { Link } from "react-router-dom";
import type { ShadowRow } from "../api";
import { Loading, Refused } from "../components/Shell";
import { useApi } from "../useApi";
import { Scrolls } from "../components/Table";

interface Payload {
  rows: ShadowRow[];
  summary: {
    total: number; outcomes_not_recorded: number;
    events_not_notified: number; correspondence_unattached: number;
  };
}

const GROUPS: [string, string][] = [
  ["outcome_not_recorded", "Outcome the register does not show"],
  ["event_not_notified", "Compensation event nobody notified"],
  ["correspondence_unattached", "Correspondence attached to no event"],
];

export function Shadow() {
  const { data, error, loading } = useApi<Payload>("/shadow");
  if (loading) return <Loading />;
  if (error) return <Refused status={error.status} detail={error.detail} />;
  if (!data) return null;

  return (
    <>
      <h1>Shadow register</h1>
      <p className="standfirst">
        What the contract says, against what the register does. The register
        records what somebody typed into it; NEC4 operates whether or not
        anybody typed anything.
      </p>

      <div className="kpis">
        <div><div className="v">{data.summary.outcomes_not_recorded}</div><div className="k">outcomes not shown</div></div>
        <div><div className="v">{data.summary.events_not_notified}</div><div className="k">events nobody notified</div></div>
        <div><div className="v">{data.summary.correspondence_unattached}</div><div className="k">letters attached to nothing</div></div>
        <div><div className="v">{data.summary.total}</div><div className="k">divergences</div></div>
      </div>

      {data.summary.total === 0 && (
        <div className="note">
          <span className="h">The register and the contract agree</span>
          Nothing has taken effect that the register does not show.
        </div>
      )}

      {GROUPS.map(([kind, heading]) => {
        const rows = data.rows.filter((r) => r.kind === kind);
        if (!rows.length) return null;
        return (
          <section className="card" key={kind}>
            <h2 className="secttl">{heading} <span className="mn withheld">{rows.length}</span></h2>
            <Scrolls>
              <table>
                <thead>
                  <tr><th>Ref</th><th>The register says</th><th>The contract says</th><th>Clause</th></tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={`${r.kind}-${r.reference}-${i}`}>
                      <td className="mn">
                        {r.reference !== "—"
                          ? <Link to={`/events/${encodeURIComponent(r.reference)}`}>{r.reference}</Link>
                          : "—"}
                      </td>
                      <td>{r.register_says}</td>
                      <td>
                        {r.contract_says}
                        {r.detail && <span className="k">{r.detail}</span>}
                      </td>
                      <td className="mn">{r.clause}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Scrolls>
          </section>
        );
      })}

      <div className="note">
        <span className="h">Nothing here is written to the register</span>
        Neev is read-first. This is a statement of divergence for a person to act on.
      </div>
    </>
  );
}
